import { useCallback } from 'react';
import { useTranslation } from './I18nContext';

/**
 * Перевод текстов, которые дилер может задать сам (#1431): значок и сноски
 * пакета финансирования, подпись CTA, пошлина. Их значения по умолчанию —
 * тексты Andys («…through Eurobank»), и переводить их можно только на
 * собственном стоке витрины и только пока значение не переопределено.
 *
 * `(key, fallback, value = fallback)`: `value` — то, что пришло из конфига,
 * `fallback` — английский текст по умолчанию. Перевод — если провайдер
 * витрины разрешил (`translateInventory`, тот же признак своего стока, что и
 * у значений инвентаря) и значение совпадает с текстом по умолчанию. Иначе —
 * `value` как есть: у дилера ровно прежняя строка.
 */
export function useShowcaseText() {
  const { t, translateInventory } = useTranslation();
  return useCallback(
    (key, fallback, value = fallback) =>
      translateInventory && value === fallback ? t(key, fallback) : value,
    [t, translateInventory]
  );
}
